import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "title" }

import { ref, computed, watch, onMounted, watchEffect } from "vue";

import { useI18n } from "vue-i18n";

import { toast } from "@/common/utils/toast";
import { scrollToTop } from "@/common/utils/common";

import { analysisPatch } from "@/common/api/rest/analysis/analysis";
import { evaluationCrewList } from "@/common/api/rest/evaluation/crew";

import type { AnalysisType } from "@/common/types/analysis";
import type { CrewListType } from "@/common/types/crew";

import { CardAnalysisTime } from "@/components";

import { baseSelect, baseTextarea } from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'analyse',
  props: {
    data: {},
    width: { default: "100%" },
    isEdit: { type: Boolean, default: true }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const danger = ref<string | null>(null);
const assistant = ref<string | null>(null);
const technical = ref<string | null>(null);
const description = ref<string | null>(null);

const technicals = ref<{ option: string; value: string }[]>([]);
const assistants = ref<{ option: string; value: string }[]>([]);

const dangerOptions = computed(() =>
  Array.from({ length: 10 }, (_, value) => ({
    option: String(value + 1),
    value: String(value + 1),
  })),
);

function update() {
  emit("update-data");
}

function fetchCrew() {
  if (
    !props.data ||
    (assistants.value.length > 0 && technicals.value.length > 0)
  )
    return;

  evaluationCrewList(props.data.account_id, {
    evaluation_id: props.data.evaluation_id,
    limit: 100,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        assistants.value = data.list
          ?.filter((item: CrewListType) => item.type === "ASSISTANT")
          ?.map((item: CrewListType) => {
            return {
              option: item.name,
              value: item.member_id,
            };
          });

        technicals.value = data.list
          ?.filter((item: CrewListType) => item.type !== "ASSISTANT")
          ?.map((item: CrewListType) => {
            return {
              option: item.name,
              value: item.member_id,
            };
          });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function patchData(payload: Partial<AnalysisType>) {
  if (!props.data) return;

  analysisPatch(props.data.account_id, props.data.analysis_id, payload)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        update();
        fetchCrew();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function changeDanger(value: number) {
  patchData({ danger: value });
}

function changeDescription() {
  patchData({ description: description.value });
}

function changeCanceledDescription(description: string) {
  patchData({ canceled_description: description });
}

function changeTechnical(value: string) {
  if (!value) {
    patchData({
      member_id: null,
      member_name: null,
    });
    return;
  }

  const data = technicals.value.find((item) => item.value === value);
  if (!data) return;

  patchData({
    member_id: data!.value,
    member_name: data!.option,
  });
}

function changeAssistant(value: string) {
  if (!value) {
    patchData({
      assistant_id: null,
      assistant_name: null,
    });
    return;
  }

  const data = assistants.value.find((item) => item.value === value);
  if (!data) return;

  patchData({
    assistant_id: value,
    assistant_name: data!.option,
  });
}

watch(
  () => props.data?.evaluation_id,
  () => {
    fetchCrew();
  },
);

watchEffect(() => {
  technical.value = props.data?.member_id || null;
  assistant.value = props.data?.assistant_id || null;
  danger.value = String(props.data?.danger) || null;
  description.value = props.data?.description || null;
});

onMounted(() => {
  fetchCrew();
  scrollToTop("main");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["tab-component", { width: __props.width }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)("analysis.labels.analysis_status")), 1),
      (__props.data)
        ? (_openBlock(), _createBlock(_unref(CardAnalysisTime), {
            key: 0,
            "account-id": __props.data.account_id,
            "analysis-id": __props.data.analysis_id,
            status: __props.data.status,
            "start-date": __props.data.start_date,
            "start-edited": __props.data.start_edited,
            "start-edited-motive": __props.data.start_edited_motive,
            "end-date": __props.data.end_date,
            "end-edited": __props.data.end_edited,
            "end-edited-motive": __props.data.end_edited_motive,
            breaks: __props.data.breaks,
            "canceled-description": __props.data.canceled_description,
            "is-edit": __props.isEdit,
            onUpdate: _cache[0] || (_cache[0] = ($event: any) => (update())),
            onUpdateDescription: _cache[1] || (_cache[1] = ($event: any) => (changeCanceledDescription($event)))
          }, null, 8, ["account-id", "analysis-id", "status", "start-date", "start-edited", "start-edited-motive", "end-date", "end-edited", "end-edited-motive", "breaks", "canceled-description", "is-edit"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("analysis.labels.analysis_data")), 1),
      (technicals.value.length > 0)
        ? (_openBlock(), _createBlock(_unref(baseSelect), {
            key: 1,
            modelValue: technical.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((technical).value = $event)),
            value: technical.value,
            options: technicals.value,
            onChange: changeTechnical
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.labels.technical")), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "value", "options"]))
        : _createCommentVNode("", true),
      (assistants.value.length > 0)
        ? (_openBlock(), _createBlock(_unref(baseSelect), {
            key: 2,
            modelValue: assistant.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((assistant).value = $event)),
            value: assistant.value,
            options: assistants.value,
            onChange: changeAssistant
          }, {
            label: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("common.labels.assistant")), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "value", "options"]))
        : _createCommentVNode("", true),
      _createVNode(_unref(baseSelect), {
        modelValue: danger.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((danger).value = $event)),
        value: danger.value,
        options: dangerOptions.value,
        onChange: changeDanger
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("analysis.labels.risk_degree")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "options"]),
      _createVNode(_unref(baseTextarea), {
        modelValue: description.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((description).value = $event)),
        value: description.value,
        placeholder: _unref(t)('common.placeholders.describe'),
        onBlur: _cache[6] || (_cache[6] = ($event: any) => (changeDescription()))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.observations")), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"])
    ])
  ], 2))
}
}

})